import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ClientPatientPrescriptions } from '../../domain/models/clinical-history.model';
import { IClientPrescriptionsRepository } from '../../domain/repositories/client-prescriptions.repository';
import { ClientPrescriptionsRemoteDatasource } from '../datasources/remote/client-prescriptions.remote-datasource';
import { ClientClinicalHistoryMapper } from '../mappers/clinical-history.mapper';

@Injectable()
export class ClientPrescriptionsRepositoryImpl implements IClientPrescriptionsRepository {
  private readonly datasource = inject(ClientPrescriptionsRemoteDatasource);
  private readonly clinicalHistoryMapper = inject(ClientClinicalHistoryMapper);

  public getForClient(clientId: string): Observable<readonly ClientPatientPrescriptions[]> {
    return this.datasource.getForClient(clientId).pipe(
      map((dto) => dto.Patients.map((patient) => this.clinicalHistoryMapper.toPatientPrescriptions(patient))),
    );
  }

  public downloadPdf(clientId: string, patientId: string, prescriptionExternalId: string, locale: string): Observable<Blob> {
    return this.datasource.downloadPdf(clientId, patientId, prescriptionExternalId, locale);
  }
}
